/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index dialog to autogenerate all the components and extensions
 * Used by "prepareDialogs"
 */

import Dialog from './dialog/Dialog'
export * from './dialog/Dialog'
export default Dialog
